<template>
  <div>
    <iframe
      width="100%"
      height="1000px"
      :src="
        isFranchiseOrHigher
          ? 'https://lookerstudio.google.com/embed/reporting/a215da2b-0926-4597-a100-46e7b4e299f0/page/p_6yaj5ywu3c'
          : 'https://lookerstudio.google.com/embed/reporting/4183b930-cfbb-4ac3-9cb8-fb71815dff51/page/p_6yaj5ywu3c'
      "
      frameborder="0"
      style="border: 0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isNotCommonUser } from "@/constants/consultants";
import * as accountTypes from "@/modules/account/store/types";
export default {
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
    }),
    isFranchiseOrHigher() {
      return isNotCommonUser(this.user?.user_role_id);
    },
  },
};
</script>
